import { memo } from 'react';
import PropTypes from 'prop-types';

const BzTabs = ({ className="", children, ...props }) => {
    return (
        <nav>
            <div className={className} {...props}>
                {children}
            </div>
        </nav>
    );
};


BzTabs.propTypes = {
    className: PropTypes.string,
};

export default memo(BzTabs);
